import { render, staticRenderFns } from "./GestioneSchedeAdmin.vue?vue&type=template&id=bcb9f1ce&scoped=true&"
import script from "./GestioneSchedeAdmin.vue?vue&type=script&lang=js&"
export * from "./GestioneSchedeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./GestioneSchedeAdmin.vue?vue&type=style&index=0&id=bcb9f1ce&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9f1ce",
  null
  
)

export default component.exports